import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';

type Strong = {
  modifier?: 'font-color-red';
};

export function Strong(props: PropsWithChildren<Strong>) {
  return <strong className={bem('strong', props.modifier)}>{props.children}</strong>;
}
